import React, { useContext } from "react"

const withContext = (C, context) => props => {
  const ctx = useContext(context)
  return <C {...props} context={ctx} />
}

export default withContext
